module.exports = __webpack_public_path__ + "static/media/our-mission.e6ca3ef9.jpg";